import React from "react";
import "./AboutUs.css";
import bg from "./header_orange_new_on_v2.webp";
import image1 from "./about_mvv_innovation_x2.webp";
import image2 from "./about_ournetwork_x2.webp";
import image3 from "./about-us_our-people_new.jpg";
import image4 from "./hp-aboutus_image_new.webp";
import image5 from "./about_ourfuture_x2.webp";
const AboutUs = () => {

  return (
    <>
    <div className="abouts-us-section purpose-section sustainability-section">
    <main id="main" className="reskin generic-content-page overflow-x-hidden">
        <section
          className="jumbotron jumbotron-2 bg-size-cover d-flex position-relative w-100 p-0 mb-0"
          style={{
            backgroundImage: `url(${bg})`,
          }}
        >
          <div className="jumbotron-hero-header container">
            <h1
              className="m-0 font-slatepro-medium page-title display-size-1 color-white z-index-1 js-sr-intro-2 abouts-h1"
              data-sr-id="1"
            >
              About Us
            </h1>
            <ol className="breadcrumb p-0 py-2 m-0 color-white">
              <li className="breadcrumb-item color-white z-index-1">
                <a href="/" className="color-white no-underline">
                  Home Page
                </a>
              </li>
              <li className="breadcrumb-item color-white z-index-1">
                <a href="/" className="color-white no-underline">
                  Who We Are
                </a>
              </li>
              <li className="breadcrumb-item color-white z-index-1">
                <a
                  href="/who-we-are/about-us/"
                  className="color-white no-underline"
                >
                  About Us
                </a>
              </li>
            </ol>
          </div>
        </section>

        <div>
          <div>
            <section className="generic-content-block">
              <div className="container">
                <div className="row">
                  <div className="col-12 display-size-11">
                    <h3 style={{ fontSize: "32px", textAlign: "left" }}>
                      As a leading builder and operator of electronic
                      marketplaces, World Liberty Financial Ltd offers institutional, wholesale,
                      retail and corporate market participants unparalleled
                      liquidity, advanced technology and a broad range of data
                      solutions that deliver better price discovery, order
                      execution and trade workflows. World Liberty Financial Ltd Markets Inc. is a
                      publicly-traded company listed on the Nasdaq.
                    </h3>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section className="content-promotion-block gradient-background from-deep-blue to-burgundy">
              <div className="container">
                <div className="row">
                  <a
                    href="/who-we-are/our-purpose/"
                    className="col-12 col-lg-6 image-left col-featured-image-new bg-size-cover bg-size-cover-md figure order-first"
                  >
                    <div className="image-wrapper">
                      <img
                        data-src={image1}
                        className="content-promo-image"
                        alt="Mission Vision Values"
                        src={image1}
                      />
                    </div>
                  </a>
                  <div
                    className="col-12 col-lg-6 col-featured-content-new content-right js-sr-left abouts-div"
                    data-sr-id="11"
                  >
                    <div className="block-content-container">
                      <div className="content-promotion-block-content display-size-11 font-slatepro">
                        <h4>
                          <span style={{ color: "rgb(255, 255, 255)" }}>
                            Our Purpose
                          </span>
                        </h4>
                        <p>
                          <span style={{ color: "rgb(255, 255, 255)" }}>
                            We believe in the exceptional potential of
                            connecting people and technology to create lasting
                            value. We help our clients and the markets realize
                            this potential by developing long-term collaborative
                            relationships, applying innovative technologies and
                            building information and trading networks that are
                            essential to the capital markets.
                          </span>
                        </p>
                        <p>
                          <span style={{ color: "rgb(255, 255, 255)" }}>
                            We do all of this for one purpose: to create the
                            most efficient, informed and effective ways to
                            trade.
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section className="content-promotion-block">
              <div className="container">
                <div className="row">
                  <a
                    href="/our-markets/institutional/"
                    className="col-12 col-lg-6 image-right col-featured-image-new order-lg-last bg-size-cover bg-size-cover-md figure d-block order-first"
                  >
                    <div className="image-wrapper">
                      <img
                        data-src={image2}
                        className="content-promo-image"
                        alt="Our global network"
                        src={image2}
                      />
                    </div>
                  </a>
                  <div
                    className="col-12 col-lg-6 col-featured-content-new content-left js-sr-right abouts-div"
                    data-sr-id="15"
                  >
                    <div className="block-content-container">
                      <div className="content-promotion-block-content display-size-11 font-slatepro">
                        <h4>
                          <span style={{ color: "#001f3e" }}>
                            Our Global Network
                          </span>
                        </h4>
                        <p className="font-slatepro-light">
                          With a rich history of fintech innovation in fixed
                          income and derivatives markets, and a rapidly
                          expanding equity business, our clients consistently
                          benefit from better price discovery, order execution,
                          and trade workflows.
                        </p>
                        <p className="font-slatepro-light">
                          More than 3,000 clients connect to World Liberty Financial Ltd to form a
                          global network of the world’s largest banks, asset
                          managers, hedge funds, insurance companies, wealth
                          managers and retail clients. With leading offerings in
                          government bonds, mortgage securities, municipal
                          bonds, credit and derivatives, we offer over 50
                          products in more than 85 countries across the
                          globe.&nbsp;&nbsp;
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section className="content-promotion-block gradient-background from-deep-blue to-light-green">
              <div className="container">
                <div className="row">
                  <a
                    href="/who-we-are/careers/"
                    className="col-12 col-lg-6 image-left col-featured-image-new bg-size-cover bg-size-cover-md figure order-first"
                  >
                    <div className="image-wrapper">
                      <img
                        data-src={image3}
                        className="content-promo-image"
                        alt="Our People"
                        src={image3}
                      />
                    </div>
                  </a>
                  <div
                    className="col-12 col-lg-6 col-featured-content-new content-right js-sr-left abouts-div"
                    data-sr-id="12"
                  >
                    <div className="block-content-container">
                      <div className="content-promotion-block-content display-size-11 font-slatepro">
                        <h4>
                          <span style={{ color: "rgb(255, 255, 255)" }}>
                            Our People
                          </span>
                        </h4>
                        <p>
                          <span style={{ color: "rgb(255, 255, 255)" }}>
                            Our firm has over 1,350 employees, including 400+
                            technologists, focused on creating diverse execution
                            protocols and innovative workflow optimization
                            tools. We understand what is needed to trade
                            intelligently and efficiently because many of us
                            have worked on trading floors.&nbsp;
                          </span>
                        </p>
                        <p>
                          <span style={{ color: "rgb(255, 255, 255)" }}>
                            We get how you work, why you work, and what you need
                            from us. Our experience in sales and trading, back
                            office, compliance, relevant technology and
                            operations runs deep. We’ve been there.
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section className="content-promotion-block">
              <div className="container">
                <div className="row">
                  <a
                    href="/our-markets/institutional/trade-cycle/"
                    className="col-12 col-lg-6 image-right col-featured-image-new order-lg-last bg-size-cover bg-size-cover-md figure d-block order-first"
                  >
                    <div className="image-wrapper">
                      <img
                        data-src={image4}
                        className="content-promo-image"
                        alt="Our Technology"
                        src={image4}
                      />
                    </div>
                  </a>
                  <div
                    className="col-12 col-lg-6 col-featured-content-new content-left js-sr-right abouts-div"
                    data-sr-id="16"
                  >
                    <div className="block-content-container">
                      <div className="content-promotion-block-content display-size-11 font-slatepro">
                        <h4>
                          <span style={{ color: "#001f3e" }}>
                            Our Technology
                          </span>
                        </h4>
                        <p>
                          We are focused on applying innovative technology to
                          streamline and improve the trade lifecycle. That’s why
                          we have pioneered a range of award winning trading
                          protocols and straight-through-processing to offer
                          better electronic execution, post-trade analysis and
                          market data.
                        </p>
                        <p>
                          Over the last decade, we expanded our platform
                          coverage to not only support multi-dealer to customer
                          markets, but also wholesale and retail segments of the
                          market.&nbsp;World Liberty Financial Ltd is chosen above other
                          marketplaces because of our ongoing commitment to
                          partnering with clients to build better markets.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div>
            <section className="content-promotion-block gradient-background from-light-grey to-light-grey">
              <div className="container">
                <div className="row">
                  <a
                    href="/who-we-are/leadership/"
                    className="col-12 col-lg-6 image-left col-featured-image-new bg-size-cover bg-size-cover-md figure order-first"
                  >
                    <div className="image-wrapper">
                      <img
                        data-src={image5}
                        className="content-promo-image"
                        alt="Silhouette of a woman standing in front of a modern high-rise building"
                        src={image5}
                      />
                    </div>
                  </a>
                  <div
                    className="col-12 col-lg-6 col-featured-content-new content-right js-sr-left abouts-div"
                    data-sr-id="13"
                  >
                    <div className="block-content-container">
                      <div className="content-promotion-block-content display-size-11 font-slatepro">
                        <h4>
                          <span style={{ color: "#001f3e" }}>Our Future</span>
                        </h4>
                        <p>
                          Clients rely on World Liberty Financial Ltd to drive the evolution of
                          electronic trading through flexible trading
                          architecture and more efficient, transparent
                          markets.&nbsp; We bring together specialists in market
                          structure, data, trading and technology to analyze
                          issues and work to effect changes that transform
                          markets to the benefit of all participants. &nbsp;
                        </p>
                        <p>
                          Always at the cusp of what’s next, we help shape
                          tomorrow’s markets.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div></div>
        </div>
      </main>
    </div>
    
    </>
  );
};

export default AboutUs;
